import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleMarker } from "../../../../actions/Map/mapActions";
import { getIconsToggle } from "../../../../actions/Map/dataActions";
import styles from "./ToggleBox.scss";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

class ToggleBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			markersArray: [],
			Icons: []
		};
	}

	componentDidMount() {
		getIconsToggle().then(res => {
			this.setState({
				Icons: res.data
			});
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.loading === true &&
		this.props.loading === false){
			this.getTogglesFromURL();
		}
	}

	getTogglesFromURL = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const marker = urlParams.get('toggle');
		if (marker){
			this.props.toggleMarker(marker);
		}
	}

	toggleMarkerIfDoneLoading = marker => {
		if (!this.props.loading) {
			this.props.toggleMarker(marker);
		}
	};

	getClass = marker => {
		return classnames(
			styles["toggle-icon"],
			{ [styles["loading"]]: this.props.loading },
			{ [styles["toggled"]]: this.props.toggleMarkers[marker] }
		);
	};

	scrollRight = () => {
		if (this.refs.scroller) this.refs.scroller.scrollLeft += 100;
	};

	scrollLeft = () => {
		if (this.refs.scroller) this.refs.scroller.scrollLeft -= 100;
	};

// Requested Order of Buttons:
	// • Entertainment
	// • Restaurants
	// • Groceries
	// • Transit
	// • Culture
	// • Faith
	// • Healthcare
	// • Parks
	// • Sports
	// • Dog Parks
	// • Trails
	// • Marinas
	// • Schools
	// • Child Care
	// • Library
	// • Transportation


	render() {
		let Icons = this.state.Icons;
		return (
			<div className={styles.togglebox}>
				<button
					className={classnames(styles.buttonLeft, styles.buttonLeftAndRight)}
					onClick={() => this.scrollLeft()}
				>
					<FontAwesomeIcon
					icon={faAngleLeft}
					className={styles.bounceLeft}
					size={"2x"} />
				</button>
				<button
					className={classnames(styles.buttonRight, styles.buttonLeftAndRight)}
					onClick={() => this.scrollRight()}
				>
					<FontAwesomeIcon
					icon={faAngleRight}
					className={styles.bounceRight}
					size={"2x"} />
				</button>

				<div className={styles.toggles} ref={"scroller"}>

					<div className={this.getClass("entertainment")}>
						<img
							alt="entertainment"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("entertainment")
							}
							src={Icons.entertainment}
						/>

						<p>Entertain.</p>
					</div>

					<div className={this.getClass("restaurants")}>
						<img
							alt="restaurants"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("restaurants")
							}
							src={Icons.restaurant}
						/>
						<br />
						<p>Restaurants</p>
					</div>

					<div className={this.getClass("grocerystores")}>
						<img
							alt="grocerystores"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("grocerystores")
							}
							src={Icons.store}
						/>
						<br />
						<p>Groceries</p>
					</div>

					<div className={this.getClass("transit")}>
						<img
							alt="transit"
							onClick={() => {
								this.toggleMarkerIfDoneLoading("transit")
								this.toggleMarkerIfDoneLoading("transportation")
							}
							}
							src={Icons.transit}
						/>
						<br />
						<p>Transit</p>
					</div>

					<div className={this.getClass("culture")}>
						<img
							alt="culture"
							onClick={() => {
								this.toggleMarkerIfDoneLoading("culture")
								this.toggleMarkerIfDoneLoading("worship")
							}
							}
							src={Icons.culture}
						/>
						<br />
						<p>Culture</p>
					</div>
{ /** Comined worship with culture
					<div className={this.getClass("worship")}>
						<img
							alt="worship"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("worship")
							}
							src={Icons.worship}
						/>
						<br />
						<p>Faith</p>
					</div>
**/}
					<div className={this.getClass("healthcare")}>
						<img
							alt="healthcare"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("healthcare")
							}
							src={Icons.healthcare}
						/>
						<br />
						<p>Healthcare</p>
					</div>

					<div className={this.getClass("parks")}>
						<img
							alt="parks"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("parks")
							}
							src={Icons.park}
						/>
						<br />
						<p>Parks</p>
					</div>

					<div className={this.getClass("sports")}>
						<img
							alt="sports"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("sports")
							}
							src={Icons.sports}
						/>
						<br />
						<p>Sports</p>
					</div>

					<div className={this.getClass("dogparks")}>
						<img
							alt="dogparks"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("dogparks")
							}
							src={Icons.dogpark}
						/>
						<br />
						<p>Dog Parks</p>
					</div>

					<div className={this.getClass("trails")}>
						<img
							alt="trails"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("trails")
							}
							src={Icons.trail}
						/>
						<br />
						<p>Trails</p>
					</div>

					<div className={this.getClass("marinas")}>
						<img
							alt="marinas"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("marinas")
							}
							src={Icons.marina}
						/>
						<br />
						<p>Marinas</p>
					</div>


					<div className={this.getClass("schools")}>
						<img
							alt="schools"
							onClick={() => {
								this.toggleMarkerIfDoneLoading("schools")
								this.toggleMarkerIfDoneLoading("libraries")
							}
							}
							src={Icons.school}
						/>
						<br />
						<p>Education</p>
					</div>

					<div className={this.getClass("childcare")}>
						<img
							alt="childcare"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("childcare")
							}
							src={Icons.childcare}
						/>
						<br />
						<p>Child Care</p>
					</div>
{		/**		Combined Libraries and education
					<div className={this.getClass("libraries")}>
						<img
							alt="libraries"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("libraries")
							}
							src={Icons.library}
						/>
						<br />
						<p>Libraries</p>
					</div>
**/}
					{ /** Combined Tranist & Transportation

					<div className={this.getClass("transportation")}>
						<img
							alt="transportation"
							onClick={() =>
								this.toggleMarkerIfDoneLoading("transportation")
							}
							src={Icons.transportation}
						/>
						<br />
						<p>Transportation</p>
					</div>
					**/}

					{/*<div className={this.getClass("houses")}>
          <img
            alt="house"
            onClick={() => this.toggleMarkerIfDoneLoading("houses")}
            src={Icons.house}
          />
          <br />
          <p>Housing</p>
        </div>*/}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		// loading: state.map.loading,
		toggleMarkers: state.map.toggleMarkers,
		externalToggles: state.survey.externalToggles
	};
}

const actions = {
	toggleMarker
};

export default connect(
	mapStateToProps,
	actions
)(ToggleBox);



// WEBPACK FOOTER //
// ./src/components/pages/Map/ToggleBox/ToggleBox.js